import type { RGProduct } from "@raumagarn/formatters";
import { baseFormat, defineFormatter } from "@trydig/centra/formatting";
import type { ProductDetails } from "./productDetails";
import type { ProductPricelist } from "./types";

export const rootFormatter = defineFormatter((product: RGProduct) => {
	return {
		...baseFormat(product),
		name: product.name,
		uri: product.uri,
		id: product.product,
		variantName: product.variantName,
		productType: product.pr_product_type_type,
		pricelist: product.prices as ProductPricelist,
		categories: undefined as RGProduct["categories"],
		relation: product.relation,
		centraProduct: product.centraProduct,
		centraVariant: product.centraVariant,
		language: product.pr_language,

		/**
		 * If the product is a single size that size is available here
		 */
		size: product.items?.length === 1 ? product.items[0] : undefined,
		fits: undefined,
		itemTable: product.itemTable,
	};
});

export type RootProduct = ReturnType<typeof rootFormatter>;
export type PricelistItem = NonNullable<Pricelist>[string];
export type Pricelist = RootProduct["pricelist"];
export type Variant = ProductDetails["variants"][number];

export * from "./algolia";
export * from "./cartItem";
export * from "./cartItem/utils";
export * from "./config";
export * from "./productCard";
export * from "./productDetails";
export * from "./types";
